import { X, Sparkles } from "lucide-react";
import { motion } from "framer-motion";
import { scrollToId } from "@/lib/site";

export const FestivalBanner = ({ banner, onClose }) => {
  const isUrl = (banner.cta_target || "").startsWith("http");
  const label = banner.cta_label || "";

  return (
    <motion.div
      data-testid="festival-banner"
      initial={{ y: -40 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-x-0 top-0 z-[96] flex h-10 items-center overflow-hidden bg-gradient-to-r from-[#8C6A15] via-[#D4AF37] to-[#8C6A15]"
    >
      <div className="mx-auto flex w-full max-w-7xl items-center justify-center gap-3 px-4 pr-9 lg:px-8">
        <Sparkles size={13} className="hidden shrink-0 text-[#2B1A00] sm:block" />
        <p data-testid="festival-banner-text" className="truncate text-center text-[12px] font-medium text-[#231502] sm:text-sm">
          {banner.text}
        </p>
        {label &&
          (isUrl ? (
            <a
              data-testid="festival-banner-cta"
              href={banner.cta_target}
              target="_blank"
              rel="noreferrer"
              className="hidden shrink-0 rounded-full bg-[#0B1428] px-3.5 py-1 text-[11px] font-medium text-[#F3E5AB] transition-transform hover:scale-105 sm:block"
            >
              {label}
            </a>
          ) : (
            <button
              data-testid="festival-banner-cta"
              onClick={() => scrollToId(banner.cta_target || "contact")}
              className="hidden shrink-0 rounded-full bg-[#0B1428] px-3.5 py-1 text-[11px] font-medium text-[#F3E5AB] transition-transform hover:scale-105 sm:block"
            >
              {label}
            </button>
          ))}
      </div>
      <button
        data-testid="festival-banner-close"
        onClick={onClose}
        aria-label="Dismiss offer"
        className="absolute right-3 text-[#231502]/70 transition-colors hover:text-[#231502]"
      >
        <X size={14} />
      </button>
    </motion.div>
  );
};
